export default __webpack_public_path__ + "static/avenir-next-semi-bold-2a0cec709a4166a967dca324bed05a06.otf";